import api from '@/apis/sys/sYSAuditingLogAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('sYSAuditingLog', api);

const state = {
  ...crud.state,
  _config: {
    table: 'msc_auditing_log',
    field: {
      key: 'id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  async updatePaging(context, payload) {
    context.commit('setPaging', payload);
  },
  async updateLoading(context, value) {
    context.commit('updateLoading', value);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
